export function formValid(data: any, errors: any) {
  console.log(data,errors);
  const bypassFields = [
  "account_holder_name",
  "account_number",
  "bank_name",
  "branch_location",
  "domains",
  "description",
  "privacy_policy",
  "directors_name", 
  "disbursement_option",
  "identifier_code",
  "legal_structure",
  "license_permits",       // []
  "privacy_policy",        // []
  "tax_identification_number",
  "tax_payerId",
  "terms_conditions",      // []
]
  let valid = true
  errors &&
    Object.values(errors).forEach((val: any) => {
      val.length > 0 && (valid = false)
    })
  data &&
    Object.entries(data).forEach(([key, val]) => {
      if (bypassFields.includes(key)) return

      const isEmpty =
        val === "" ||
        val === null ||
        val === undefined ||
        (Array.isArray(val) && (val.length === 0 || val.every(v => typeof v === "string" && v.trim() === "")))

      if (isEmpty) valid = false
    })

  return valid
}


export const hasNonEmptyValues = (data: any): boolean => {
  return Object.values(data).some((value) => {
    if (Array.isArray(value)) {
      
      return value.length > 0;
    }
    console.log(value);
    
    return value !== null && value !== undefined && value !== '';
  });
};

export const formatSalaryDate = (date: string) => {
    const day = parseInt(date)
    if (!day) return "";



    const suffix =
        day % 10 === 1 && day !== 11
            ? "st"
            : day % 10 === 2 && day !== 12
            ? "nd"
            : day % 10 === 3 && day !== 13
            ? "rd"
            : "th";

    return `${day}${suffix}`;
};

export function errorValid(data: any) {
  let valid = true
  data &&
    Object.values(data).forEach((val: any) => {
      return (
        val &&
        Object.values(val).forEach((subVal: any) => {
          subVal.length === 0 && (valid = false)
        })
      )
    })

  return valid
}
